"use client";

import { Box } from "@mui/material";
import Image from "next/image";
import { motion, useInView } from "framer-motion";
import { useRef } from "react";

export const OverlappingDiagrams = () => {
  const ref = useRef<HTMLDivElement>(null);
  const isInView = useInView(ref, { once: true, amount: 0.3 });

  return (
    <Box
      ref={ref}
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        position: "relative",
        width: "100%",
        height: { xs: "750px", sm: "500px" },
        marginTop: { xs: 8, sm: 12 },
        marginBottom: { xs: 1, sm: 1.5 },
        overflow: "visible",
      }}
    >
      {/* Preexisting - top on mobile, left on desktop */}
      <Box
        sx={{
          position: "absolute",
          top: { xs: 0, sm: "auto" },
          left: { xs: "50%", sm: "auto" },
          right: { xs: "auto", sm: "48%" },
          transform: { xs: "translateX(-50%)", sm: "none" },
          zIndex: 1,
          width: { xs: "300px", sm: "480px" },
          maxWidth: { xs: "90vw", sm: "480px" },
        }}
      >
        <motion.div
          initial={{ y: 50 }}
          animate={
            isInView
              ? {
                  y: 0,
                }
              : { y: 50 }
          }
          transition={{
            duration: 0.8,
            ease: [0.34, 1.56, 0.64, 1],
          }}
        >
          <Image
            src="/sections/03-harmful-design-patterns-in-finance/images/preexisting.svg"
            alt=""
            width={480}
            height={480}
            style={{ width: "100%", height: "auto" }}
          />
        </motion.div>
      </Box>

      {/* Financial Services - bottom on mobile (overlapping), right on desktop */}
      <Box
        sx={{
          position: "absolute",
          top: { xs: "320px", sm: "auto" },
          left: { xs: "50%", sm: "48%" },
          transform: { xs: "translateX(-50%)", sm: "none" },
          zIndex: 2,
          width: { xs: "300px", sm: "480px" },
          maxWidth: { xs: "90vw", sm: "480px" },
        }}
      >
        <motion.div
          initial={{ y: 50 }}
          animate={
            isInView
              ? {
                  y: 0,
                }
              : { y: 50 }
          }
          transition={{
            duration: 0.8,
            delay: 0.2,
            ease: [0.68, -0.55, 0.265, 1.55],
          }}
        >
          <Image
            src="/sections/03-harmful-design-patterns-in-finance/images/financial-services.svg"
            alt=""
            width={480}
            height={480}
            style={{ width: "100%", height: "auto" }}
          />
        </motion.div>
      </Box>
    </Box>
  );
};
